/* eslint-disable max-lines-per-function */
import React from "react";
import { Link } from "react-router-dom";
import { Container } from "@mui/material";

const Footer: React.FC = () => {
  const currYear = new Date().getFullYear();
  return (
    <footer className="footer" role="contentinfo" style={{ marginTop: "auto" }}>
      <Container maxWidth="md" style={{ textAlign: "center" }}>
        <ul className="list-horz">
          <li>
            <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/privacy-policy.pdf" rel="noreferrer">
              Privacy Policy
            </a>
          </li>

          <li>
            <span className="termsOfService">
              <Link to="/terms">Terms of service</Link>:
            </span>
            <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/manager-terms.pdf" rel="noreferrer">
              Property Manager
            </a>
            <b className="footerPipe">|</b>
            <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/applicant-terms.pdf" rel="noreferrer">
              Applicant
            </a>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/careers">Careers</Link>
          </li>
        </ul>
        <ul className="list-horz">
          <li>
            <a target="_blank" href="https://www.facebook.com/havenconnect1/" rel="noreferrer">
              <img
                src="https://s3.amazonaws.com/hc-images2/social-facebook.png"
                alt="Facebook logo"
                className="sociaMediaIcon"
              />
              Facebook
            </a>
          </li>
          <li>
            <a target="_blank" href="https://twitter.com/havenconnect" rel="noreferrer">
              <img
                src="https://s3.amazonaws.com/hc-images2/social-twitter.png"
                alt="Twitter logo"
                className="sociaMediaIcon"
              />
              Twitter
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.linkedin.com/company/haven-connect/" rel="noreferrer">
              <img
                src="https://s3.amazonaws.com/hc-images2/social-linkedin.png"
                alt="LinkedIn logo"
                className="sociaMediaIcon"
              />
              LinkedIn
            </a>
          </li>
        </ul>

        <div>
          <div className="ft-name">&#169; {currYear} Haven Connect</div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
